import React from 'react';

/**
 * Top header bar with page title and sign-out button.
 *
 * Before: this was inline JSX inside Dashboard.js.
 * Now a reusable layout component.
 */
export default function Header({ title = 'Dashboard', onLogout }) {
  return (
    <div className="h-[60px] px-6 bg-white border-b border-gray-200 flex justify-between items-center box-border">
      <h1 className="m-0 text-[25px] font-semibold text-gray-900 font-[Arial]">
        {title}
      </h1>
      <button
        onClick={onLogout}
        className="px-4 py-2 bg-white text-gray-500 border border-gray-200 rounded-md cursor-pointer text-sm font-medium hover:bg-gray-50 transition-colors"
      >
        Sign Out
      </button>
    </div>
  );
}
